import React, { useState, useEffect } from 'react'
import WaveDivider from './WaveDivider'

const REVIEWS_BY_LANG = {
  da: {
    tag: 'Ægte kundeoplevelser',
    title: 'Glade Kunder',
    reviews: [
      {
        id: 1,
        quote:
          'Vi har netop fået de mest fantastiske cookies (formentlig nogensinde) samt et par rigtig gode kopper kaffe.\n\nDet er ikke sidste gang vi kommer her.',
        author: 'Poul Otto Schousboe',
        badge: 'Cafégæst',
        rating: 5,
      },
      {
        id: 2,
        quote:
          'Var på flødebolle kursus ved Karina i dag.\n\nStemningen var afslappet og Karina var virkelig dygtig til at fortælle og instruere så alle kan være med. Smager fantastisk.\n\nKan kun anbefale det!',
        author: 'Mads Strandgaard Jensen',
        badge: 'Kursusdeltager',
        rating: 5,
      },
      {
        id: 3,
        quote:
          'Har lige fået kage-Tapas fra Fanø Chokolade, bestilt til datterens konfirmation. Har aldrig haft så glad en datter og gæster ikke mindst. Alle var henrykte over kaffebordets glæder.\n\nSå tusind tak til Fanø Chokolade og Karina, for at fuldende datterens konfirmation.\n\nDet er bestemt ikke sidste gang, vi prøver det. Og det kan helt klart varmt anbefales.',
        author: 'Anelle Sørensen',
        badge: 'Kagebestilling',
        rating: 5,
      },
    ],
  },
  en: {
    tag: 'Customer Experiences',
    title: 'Happy Guests',
    reviews: [
      {
        id: 1,
        quote:
          'We just had the most fantastic cookies (probably ever) along with a couple of great cups of coffee.\n\nThis is definitely not the last time we visit.',
        author: 'Poul Otto Schousboe',
        badge: 'Café Guest',
        rating: 5,
      },
      {
        id: 2,
        quote:
          'Attended a handmade cream puff and chocolate workshop with Karina today.\n\nThe atmosphere was wonderfully relaxed and Karina was exceptional at guiding everyone. Tastes heavenly.\n\nHighly recommended!',
        author: 'Mads Strandgaard Jensen',
        badge: 'Workshop Participant',
        rating: 5,
      },
      {
        id: 3,
        quote:
          'Ordered cake tapas from Fanø Chokolade for our daughter’s confirmation celebration. All our guests were completely enchanted by the delicious treats.\n\nA huge thank you to Fanø Chokolade and Karina for making her celebration unforgettable.\n\nWarmest recommendations!',
        author: 'Anelle Sørensen',
        badge: 'Cake Order',
        rating: 5,
      },
    ],
  },
  de: {
    tag: 'Echte Gästestimmen',
    title: 'Glückliche Kunden',
    reviews: [
      {
        id: 1,
        quote:
          'Wir hatten gerade die fantastischsten Cookies (wahrscheinlich überhaupt) und dazu erstklassigen Kaffee.\n\nWir kommen ganz sicher wieder!',
        author: 'Poul Otto Schousboe',
        badge: 'Cafégast',
        rating: 5,
      },
      {
        id: 2,
        quote:
          'Habe heute an einem Schokoladenkurs bei Karina teilgenommen.\n\nDie Atmosphäre war herrlich entspannt und Karina hat alles wunderbar erklärt, sodass jeder mitmachen konnte. Schmeckt himmlisch!\n\nSehr zu empfehlen!',
        author: 'Mads Strandgaard Jensen',
        badge: 'Kursteilnehmer',
        rating: 5,
      },
      {
        id: 3,
        quote:
          'Wir haben Kuchen-Tapas für die Konfirmationsfeier unserer Tochter bestellt. Unsere Gäste und unsere Tochter waren restlos begeistert.\n\nVielen Dank an Fanø Chokolade und Karina für das kulinarische Highlight.\n\nWärmste Empfehlung!',
        author: 'Anelle Sørensen',
        badge: 'Tortenbestellung',
        rating: 5,
      },
    ],
  },
}

export default function ReviewsSlider({ lang = 'da' }) {
  const content = REVIEWS_BY_LANG[lang] || REVIEWS_BY_LANG.da
  const reviews = content.reviews
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isPaused, setIsPaused] = useState(false)
  const total = reviews.length

  useEffect(() => {
    if (isPaused) return
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total)
    }, 6000)
    return () => clearInterval(timer)
  }, [isPaused, total])

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total)
  }

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % total)
  }

  const current = reviews[currentIndex]

  return (
    <section className="py-16 sm:py-20 bg-[#FDF8F7] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-script text-4xl sm:text-5xl text-[#C68D94] font-normal mt-2 mb-4">
            {content.title}
          </h2>
          <WaveDivider className="text-[#C68D94]/50 mx-auto" />
        </div>

        {/* Carousel Container */}
        <div
          className="relative"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-[#C68D94]/20 relative">
            {/* Decorative Quote Icon Badge - Centered, overflowing top of box, completely round */}
            <div className="absolute -top-6 sm:-top-7 left-1/2 -translate-x-1/2 w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full border border-[#C68D94]/30 shadow-sm flex items-center justify-center text-[#C68D94] z-10 pointer-events-none select-none">
              <i className="fa-solid fa-quote-left text-lg sm:text-xl text-[#C68D94]" aria-hidden="true" />
            </div>

            {/* Quote Body */}
            <blockquote className="text-center text-xs sm:text-sm text-[#3E3435]/90 font-light leading-relaxed min-h-[110px] flex items-center justify-center mb-6 px-4 whitespace-pre-line">
              <p>"{current.quote}"</p>
            </blockquote>

            {/* Author & Badge */}
            <div className="text-center pt-2">
              <cite className="not-italic font-semibold text-sm sm:text-base text-[#3E3435] block">
                {current.author}
              </cite>
              <span className="inline-block mt-1 text-[11px] uppercase tracking-wider font-medium text-[#A35D67]">
                {current.badge}
              </span>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              type="button"
              onClick={prevReview}
              className="w-9 h-9 flex items-center justify-center text-[#3E3435] hover:text-[#A35D67] transition-colors cursor-pointer"
              aria-label="Previous review"
            >
              <i className="fa-solid fa-chevron-left text-base" aria-hidden="true" />
            </button>

            {/* Dots */}
            <div className="flex items-center gap-2">
              {reviews.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setCurrentIndex(idx)}
                  className={`transition-all duration-300 rounded-full ${
                    currentIndex === idx
                      ? 'w-7 h-2.5 bg-[#A35D67]'
                      : 'w-2.5 h-2.5 bg-[#C68D94]/30 hover:bg-[#C68D94]/60'
                  }`}
                  aria-label={`Gå til anmeldelse ${idx + 1}`}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={nextReview}
              className="w-9 h-9 flex items-center justify-center text-[#3E3435] hover:text-[#A35D67] transition-colors cursor-pointer"
              aria-label="Next review"
            >
              <i className="fa-solid fa-chevron-right text-base" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
